import { styles } from "../../sections/home/cover_section";
import { useI18n } from "@/i18n/I18nProvider";
import Box from '@mui/material/Box';
import dynamic from "next/dynamic";
import { colors } from "@/utils/const";
import Navigation_Bar from "@/sections/why_contact/navigation_bar";
import Header from "@/sections/why_contact/header_section";
const Expertise_And_Trust = dynamic(() =>
  import("@/sections/why_contact/expertise_and_trust")
);
const Services = dynamic(() => import("@/sections/why_contact/services"));
const Financing_Insurance_Products = dynamic(() =>
  import("@/sections/why_contact/financing_insurance_products")
);
const Ambition_Section = dynamic(() =>
  import("@/sections/why_contact/ambition_section")
);
const PageHead = dynamic(() => import("@/components/PageHead"));

export default function Why_Contact() {
  const { t, locale } = useI18n();

  return (
    <Box
      sx={{
        backgroundColor: colors.light_biege,
      }}
    >
      <PageHead
        title={t.pages_main_tags.whyContact.title}
        description={t.pages_main_tags.whyContact.meta_desc}
      />
      <main className={styles.main}>
        <Navigation_Bar />
        <Header />
        <Expertise_And_Trust />
        <Services />
        <Financing_Insurance_Products />
        <Ambition_Section />
      </main>
    </Box>
  );
}
